import { lazy } from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink, Link } from 'react-router-dom';

import { DefaultUserMenu } from '@rio-cloud/rio-user-menu-component';
import { RioNotifications } from '@rio-cloud/rio-notifications-component';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';

import { config } from '../../config';
import SuspendedWithSpinner from '../../components/SuspendedWithSpinner';
import ServiceInfo from './ServiceInfo';
import { DEFAULT_ROUTE, INCOMING_ROUTE, OUTGOING_ROUTE } from '../../routes/routes';

const AppMenu = lazy(() => import('./AppMenu'));

const AppHeader = () => {
    const navItems = [
        {
            key: 'start',
            route: (
                <NavLink to={`${DEFAULT_ROUTE}`}>
                    <FormattedMessage id='intl-msg:orderexchange.label.start' />
                </NavLink>
            ),
        },
        {
            key: 'incoming',
            route: (
                <NavLink to={`${INCOMING_ROUTE}`}>
                    <FormattedMessage id='intl-msg:orderexchange.label.incoming' />
                </NavLink>
            ),
        },
        {
            key: 'outgoing',
            route: (
                <NavLink to={`${OUTGOING_ROUTE}`}>
                    <FormattedMessage id='intl-msg:orderexchange.label.outgoing' />
                </NavLink>
            ),
        },
    ];

    const environment = import.meta.env.PROD ? 'production' : 'local';

    const serviceInfoItem = <ServiceInfo />;
    const notifications = <RioNotifications />;
    const userMenuItem = <DefaultUserMenu environment={environment} />;

    return (
        <ApplicationHeader
            label={<FormattedMessage id={'intl-msg:orderexchange.title'} />}
            appNavigator={
                <SuspendedWithSpinner>
                    <AppMenu />
                </SuspendedWithSpinner>
            }
            homeRoute={<Link to={config.homeRoute || ''} />}
            navItems={navItems}
            actionBarItems={[serviceInfoItem, notifications, userMenuItem]}
        />
    );
};

export default AppHeader;
